import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { hasPermission } from '../../auth/permissions';
import './modules.css';

const items = [
  ['/modules', 'All modules', null],
  ['/security', 'Security', 'ivt.read'],
  ['/notifications', 'Notifications', 'workspace.read'],
  ['/incidents', 'Incidents', 'workspace.read'],
  ['/reports', 'Reports', 'workspace.read'],
  ['/my-dashboards', 'My dashboards', 'workspace.read'],
  ['/adsense', 'AdSense', 'workspace.read'],
  ['/goals', 'Goals & funnels', 'workspace.read'],
  ['/work', 'Tasks & support', 'workspace.read'],
  ['/account', 'Account', null],
  ['/admin', 'Admin', 'admin.manage'],
];

export default function ModuleNav() {
  return (
    <nav className="sec-nav">
      <Link to="/">← Dashboard</Link>
      {items.filter(([, , p]) => !p || hasPermission(p)).map(([to, label]) => (
        <NavLink key={to} to={to} className={({ isActive }) => (isActive ? 'active' : '')}>{label}</NavLink>
      ))}
    </nav>
  );
}
